import { label } from "constants/labels";

const EmptyWorkspace = () => {
  return (
    <div
      className="w-full h-full flex items-center justify-center relative text-palette-5 italic"
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
      }}
    >
      {label("workspace_empty_instructions")}
    </div>
  );
};

export default EmptyWorkspace;
